import { Col, Flex, Input, Row, Select, Space } from "antd"
import { AllStates } from "../../config"
import { AddressInterface } from "../../types"

export const AddressInput = (props: {
    address?: AddressInterface
    setAddress?: React.Dispatch<React.SetStateAction<AddressInterface | undefined>>
}): JSX.Element => {
    return (
        <div>
            <Flex vertical gap="large">
                <Input
                    addonBefore="Address Line 1"
                    type="text"
                    id="line1"
                    value={props.address?.line1}
                    onChange={(e) => {
                        props.setAddress?.({
                            ...props.address,
                            line1: e.target.value,
                        })
                    }}
                    size="middle"
                    // maxLength={60}
                    name="line1"
                />
                <Input
                    addonBefore="Address Line 2"
                    type="text"
                    id="line2"
                    value={props.address?.line2}
                    onChange={(e) => {
                        props.setAddress?.({
                            ...props.address,
                            line2: e.target.value,
                        })
                    }}
                    size="middle"
                    // maxLength={60}
                    name="line2"
                />

                <Row gutter={[16, 16]}>
                    <Col md={8} xs={24}>
                        <Input
                            addonBefore="City"
                            type="text"
                            id="city"
                            value={props.address?.city}
                            onChange={(e) => {
                                props.setAddress?.({
                                    ...props.address,
                                    city: e.target.value,
                                })
                            }}
                            size="middle"
                            name="city"
                            style={{ width: "100%" }}
                        />
                    </Col>
                    <Col md={9} xs={24}>
                        <Space.Compact style={{ display: 'flex', width: '100%' }}>
                            <span
                                style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    background: "#fafafa",
                                    border: "1px solid #d9d9d9",
                                    borderRight: 0,
                                    borderRadius: "6px 0 0 6px",
                                    height: 30,
                                    padding: "0 11px",
                                    fontSize: 14,
                                    fontWeight: 400,
                                    color: "rgba(0, 0, 0, 0.88)",
                                    whiteSpace: "nowrap",
                                    minWidth: "fit-content",
                                }}
                            >
                                State
                            </span>
                            <Select
                                style={{
                                    
                                    flex: 1,
                                    borderRadius: "0 6px 6px 0",
                                }}
                                placeholder="Select a state"
                                value={props.address?.state}
                                onChange={(value) => {
                                    props.setAddress?.({ ...props.address, state: value })
                                }}
                                optionFilterProp="label"
                                showSearch
                                options={AllStates.map((s) => {
                                    return { value: s, label: s }
                                })}
                                size="middle"
                                
                            />
                        </Space.Compact>
                    </Col>
                    <Col md={7} xs={24}>
                        <Input
                            addonBefore="Zip Code"
                            type="text"
                            id="zip"
                            value={props.address?.zip}
                            onChange={(e) => {
                                props.setAddress?.({
                                    ...props.address,
                                    zip: e.target.value,
                                })
                            }}
                            size="middle"
                            name="zip"
                        />
                    </Col>
                </Row>
            </Flex>
        </div>
    )
}
